// Environment hostnames. Unmatched → QA.
const ENV_HOSTS = {
    qa: ['us.flow-test.boomi.com'],
    euqa: ['gb.flow-test.boomi.com'],
    pc3: [''],
    pc4: [''],
    prod: ['us.flow-prod.boomi.com'],
    prodgb: ['gb.flow-prod.boomi.com'],
};

const CDN = {
    qa: 'https://cdn.uitech-pipeline.boomi.com/magnetosphere/v26/stable',
    euqa: 'https://cdn.uitech-eu-pipeline.boomi.com/magnetosphere/v26/stable',
    pc3: 'https://cdn-prodclone.uitech-production.boomi.com/magnetosphere/v26/stable',
    pc4: 'https://cdn.uitech-preprod.boomi.com/magnetosphere/v26/stable',
    prod: 'https://cdn.uitech-production.boomi.com/magnetosphere/v26/stable',
    prodgb: 'https://cdn.uitech-uk-production.boomi.com/magnetosphere/v26/stable',
};

export function getMagnetosphereCdnBase(): string {
    const h = window.location.hostname;
    // Region-specific hosts (GB prod, EU QA) are matched BEFORE the broad
    // prod / qa so a shared substring can't swallow them.
    if (ENV_HOSTS.prodgb.some((x) => x && h.includes(x))) return CDN.prodgb;
    if (ENV_HOSTS.prod.some((x) => x && h.includes(x))) return CDN.prod;
    if (ENV_HOSTS.pc3.some((x) => x && h.includes(x))) return CDN.pc3;
    if (ENV_HOSTS.pc4.some((x) => x && h.includes(x))) return CDN.pc4;
    if (ENV_HOSTS.euqa.some((x) => x && h.includes(x))) return CDN.euqa;
    if (ENV_HOSTS.qa.some((x) => x && h.includes(x))) return CDN.qa;
    return CDN.qa; // default — QA for anything unrecognized
}

export function injectMagnetosphereCdn(): void {
    if (document.querySelector('script[data-magnetosphere-cdn]')) return;
    const base = getMagnetosphereCdnBase();
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${base}/magnetosphere.css`;
    document.head.appendChild(link);
    const s = document.createElement('script');
    s.type = 'module';
    s.src = `${base}/magnetosphere.js`;
    s.setAttribute('data-magnetosphere-preload', 'boomi-masthead boomi-aisearch');
    s.setAttribute('data-magnetosphere-cdn', '');
    document.head.appendChild(s);
}
